export default {
    PAGE_INFO: {
        ACTIVATE_SECTION: 'pageInfo.activatePage',
        TOGGLE_SECTION_ACTIVATION: 'pageInfo.toggleSectionActivation',
        SET_BREAKPOINT: 'pageInfo.setBreakpoint'
    }
};
